import type { Suggestion } from "@/types/chat";

/**
 * Resolve the user message to send when a Quick Answer chip is clicked.
 * Prefers typed draft over chip text; never sends a hidden `prompt` that
 * differs from the visible `label` (prevents fabricated transcript content).
 */
export function resolveQuickAnswerMessage(
  suggestion: Suggestion,
  draftText?: string,
): string {
  const draft = draftText?.trim() ?? "";
  if (draft) return draft;

  const label = suggestion.label.trim();
  const prompt = suggestion.prompt.trim();

  if (label && prompt && label !== prompt) {
    return label;
  }

  return prompt || label;
}
